import { render, staticRenderFns } from "./PrescriptionShort.vue?vue&type=template&id=70bc9f50"
import script from "./PrescriptionShort.vue?vue&type=script&lang=js"
export * from "./PrescriptionShort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports